import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokTextHero } from "@/storyblok";

import { StoryblokComponent, type BlokProps } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import { AssetBlok, sizes } from "../Asset";
import { MediaLink } from "../MediaLink";
import styles from "./TextHero.module.css";

export const TextHeroBlok = ({
	blok,
	className,
	preview,
	...rest
}: BlokProps<BlokTextHero> & { className?: string }) => {
	const { title, description, image, button, tag, layout } = blok;

	return (
		<BlokWrap editable={blok} asChild>
			<div
				className={clsx(styles.contentWrapper, className)}
				data-bg={blok.backgroundColor}
				data-layout={layout || "default"}
				{...rest}
			>
				<div className={styles.imageContainer}>
					{tag && <span className={styles.tag}>{tag}</span>}
					{image && (
						<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
							<AssetBlok autoPlay muted loop source={image} sizes={sizes(100)} />
						</MediaLink>
					)}
				</div>
				<div className={styles.content}>
					<h2 className={styles.title}>{title}</h2>

					<p className={styles.description}>{description}</p>
					{!!button?.length && (
						<div>
							{blok.button?.map((button) => (
								<StoryblokComponent
									key={button._uid}
									blok={button}
									preview={preview}
									className={styles.button}
								/>
							))}
						</div>
					)}
				</div>
			</div>
		</BlokWrap>
	);
};
